import { useFormikContext } from 'formik';

import { Box } from '@hivebrite/design-system/Box';

import UserTargetingButton from 'hb-react/frontoffice/components/user_targeting/Button';

import { type FormValues, type Job } from '../types';

export const Notify = ({ job }: { job?: Job }) => {
  const { setFieldValue } = useFormikContext<FormValues>();

  const authorized = job?.user_targeting?.authorized;

  const maxTargetedUsers = job?.user_targeting?.max_targeted_users;

  return authorized ? (
    <Box justifyContent="flex-end" ml={6}>
      <UserTargetingButton
        displayTotalSelectedUsers
        userTargetingProps={{
          defaultQuery: { targeting_type: 'Posts::ForumPost' },
          maxTargetedUsers,
          model: job,
          onCancelSelection: () => setFieldValue('targeted_user_ids', []),
          onValidateSelection: (ids: Array<number>) =>
            setFieldValue('targeted_user_ids', ids),
        }}
      />
    </Box>
  ) : null;
};
